<template>
  <tbody v-if="Ratings">
    <tr @click="showDetail = !showDetail">
      <td>{{ $t(`${translationPrefix}${Title}`)}}</td>
      <td>
        <span
          v-if="Ratings[3]"
          v-b-tooltip.hover 
          :title="new Date(Ratings[3].Date).toLocaleString('default', {month: 'short', year: 'numeric'})">
          <span v-if="isRatingsCount">{{parseFloat(Ratings[3].Value).toFixed(0)}}</span>
          <span v-else>{{Ratings[3].Value | toOneDecimal}}</span>
          <TrendIcon
            v-if="Ratings[4]" 
            :Difference="Ratings[3].Value - Ratings[4].Value" />
        </span>
        <span v-else>-</span>
      </td>
      <td>
        <span 
          v-if="Ratings[2]"
          v-b-tooltip.hover 
          :title="new Date(Ratings[2].Date).toLocaleString('default', {month: 'short', year: 'numeric'})">
          <span v-if="isRatingsCount">{{parseFloat(Ratings[2].Value).toFixed(0)}}</span>
          <span v-else>{{Ratings[2].Value | toOneDecimal}}</span>
          <TrendIcon
            v-if="Ratings[3]"
            :Difference="Ratings[2].Value - Ratings[3].Value" />
        </span>
        <span v-else>-</span>
      </td>
      <td>
        <span 
          v-if="Ratings[1]"
          v-b-tooltip.hover
          :title="new Date(Ratings[1].Date).toLocaleString('default', {month: 'short', year: 'numeric'})">
          <span v-if="isRatingsCount">{{parseFloat(Ratings[1].Value).toFixed(0)}}</span>
          <span v-else>{{Ratings[1].Value | toOneDecimal}}</span>
          <TrendIcon
            v-if="Ratings[2]"
            :Difference="Ratings[1].Value - Ratings[2].Value" />
        </span>
        <span v-else>-</span>
      </td>
      <td>
        <span class="border-left pl-3" v-b-tooltip.hover :title="new Date(Ratings[0].Date).toLocaleString('default', {month: 'short', year: 'numeric'})">
          <template v-if="Ratings[0]">
            <b v-if="isRatingsCount">{{parseFloat(Ratings[0].Value).toFixed(0)}}</b>
            <b v-else>{{Ratings[0].Value | toOneDecimal}}</b>
            <TrendIcon 
              v-if="Ratings[1]"
              :Difference="Ratings[0].Value - Ratings[1].Value" />
          </template>
        </span>
      </td>
      <td>
        <AccomplishmentIcon v-if="!isRatingsCount" :isAccomplished="Ratings[0].Value == 100" />
      </td>
      <td>
        <font-awesome-icon 
          v-if="Ratings[0].Message_Text"
          :icon="['fas', showDetail ? 'chevron-down' : 'chevron-right' ]"></font-awesome-icon>
      </td>
    </tr>

    <tr v-if="Ratings[0].Message_Text && showDetail">
      <td colspan="7">
        <div class="p-3">
          <h5>{{Title}}</h5>
          <p v-html="Ratings[0].Message_Text"></p>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>

import TrendIcon from "@/components/Shared/TrendIcon";
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";

export default {
  name: "RatingTableRow",
  components: {
    TrendIcon,
    AccomplishmentIcon
  },
  data: function() {
    return {
      showDetail: false
    }
  },
  props: {
    Title: String,
    Ratings: Array,
    translationPrefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    isRatingsCount() {
      var res = false;
      var ratingCountTitles = [
        "ReviewCount",
        "ActiveRatingsCount",
        "UserRatingsTotal",
        "RatingsCount",
      ];
      ratingCountTitles.forEach(title => {
        if (this.Title === title) {
          res = true;
        }
      });
      return res;
    }
  }
}
</script>

<style scoped>
  td span {
    text-align: right;
    display: inline-block;
    min-width: 4rem;
  }
</style>